<template>
    <b-list-group-item :disabled="isDisabled" @click="goToNext()">
        <div >
            <b-row>
                <b-col cols="8">
                    <b-row>
                        <b-col class="list-title">
                            {{ getStringSubstringed(model.part.partNumber,20) }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            {{ model.part.partName }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            {{ model.qtyDeliver}}
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="4"  :style="getStatusStyle">
                    <div class="item-box">
                        {{ model.inspectionStatus.replace("_"," ")}}
                    </div>
                </b-col>
            </b-row>
            </div>
        </b-list-group-item>
    </template>
<script>
export default {
    props: {
        model: {
            default: {},
            type: Object
        },
        isDisabled: {
            default: Boolean,
            type: false
        }
    },
    methods: {
        goToNext() {
            if (!this.isDisabled) {
                this.$emit('nextAction');
            }
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        getStringSubstringed(valueString,length){
            if (valueString.length<length) {
                return valueString;
            }
            return valueString.substring(0,length) + "...";
        },
    },
    computed: {
        getStatusStyle() {
            var colorString = "red";
            if (this.model.inspectionStatus=="FULL_CHECK") {
                colorString = "green";
            }
            else if (this.model.inspectionStatus=="PARTIAL_CHECK") {
                colorString = "#FFC107";
            }
            return {
                color: colorString,
                // Add more styles as needed
            };
        },
    },
}
</script>
<style>
.scanStatus {
    display: flex;
    font-size: 14px !important;
    align-items: center;
    justify-content: flex-end;
}
</style>